import { Component, computed, input } from '@angular/core';
import { User } from '../../types/user.model';

@Component({
  selector: 'app-user-avatar-v2',
  imports: [],
  templateUrl: './user-avatar-v2.component.html',
  styleUrl: './user-avatar-v2.component.scss'
})
export class UserAvatarV2Component {
  user = input<User>();
  avatarUrl = input<string>();

  userAvatarUrl = computed<string>(() => this.avatarUrl() || this.user()?.avatarUrl || '');
  initials = computed<string>(() => this.user()?.initials ?? '');
  profileColor = computed<string>(() => this.user()?.profileColor ?? '#0D9443');
}
